export default "__VITE_ASSET__B4Ta_FvF__"